"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageResize_1 = require("./ImageResize");
exports.ImageResize = ImageResize_1.default;
//# sourceMappingURL=index.js.map